<main id="site-main">
  <div class="inner-content">
    <section id="hero">
      <div class="content">
        <h1>هویت دیجیتال شناورها، پایه‌ای برای توزیع هوشمند سوخت</h1>
        <h2>فرمانداری شهرستان قشم</h2>
        <button class="btn btn-primary" [routerLink]="['/login/profile']">
          ورود | ثبت‌نام
        </button>
      </div>
    </section>
  </div>
</main>

<app-footer></app-footer>
